import type { EnhancedScopeData } from '@ardoq/data-model';
import { enhancedScopeDataOperations } from '@ardoq/scope-data';

export const getComponentTypeName = (
  scopeData: EnhancedScopeData,
  node: { modelId: string | null }
): string | null => {
  if (!node.modelId || !scopeData.componentsById[node.modelId]) return null;
  return (
    enhancedScopeDataOperations.getComponentTypeByComponentId(
      scopeData,
      node.modelId
    )?.name ?? null
  );
};
